export const GET_BARANGAYS = '/get_barangays';
export const GET_SINGLE_BARANGAY = '/get_single_barangay';
export const UPDATE_BARANGAY = '/update_barangay';
export const CREATE_BARANGAY = '/create_barangay';
export const REMOVE_BARANGAY = '/remove_barangay';
export const GET_DISTRICT_LIST = 'barangay/get_district_list';

export const FORM_DATA = {
  name: '',
  code: '',
  rptax_district_id: '',
  zone_number: '',
};